<template>
  <div>
	<el-form-item label="视频地址：">
		<videoSelect :url.sync="videoSrcTemp" />
	</el-form-item>
	<el-form-item>
		<el-checkbox :value.sync="autoPlayTemp" :checked.sync="autoPlayTemp" @change="autoPlayChange">自动播放</el-checkbox>
		<el-checkbox :value.sync="loopTemp" :checked.sync="loopTemp" @change="loopChange">循环播放</el-checkbox>
		<el-checkbox :value.sync="mutedTemp" :checked.sync="mutedTemp" @change="mutedChange">静音播放</el-checkbox>
	</el-form-item>
  </div>
</template>

<script>
	import videoSelect from '@client/components/video-select'
	export default {
		name: "attr-qk-videoSrc",
		props: {
			videoSrc: String,
			autoPlay: Boolean,
			loop: Boolean,
			muted: Boolean,
		},
		components: {
			videoSelect
		},
		data() {
			return {
				videoSrcTemp: '',
				autoPlayTemp: false,
				loopTemp: false,
				mutedTemp: false,
			}
		},
		mounted() {
			this.videoSrcTemp = this.videoSrc;
			this.autoPlayTemp = this.autoPlay;
			this.loopTemp = this.loop;
			this.mutedTemp = this.muted;
		},
		methods: {
			autoPlayChange(e){
				this.$emit('update:autoPlay', e);
			},
			loopChange(e){
				this.$emit('update:loop', e);
			},
			mutedChange(e){
				this.$emit('update:muted', e);
			},
		},
		watch: {
			videoSrc(val) {
				this.videoSrcTemp = val;
			},
			videoSrcTemp() {
				this.$emit('update:videoSrc', this.videoSrcTemp);
			},
			autoPlay(val) {
				console.log(val, 'autoPlay')
				this.autoPlayTemp = val;
			},
			autoPlayTemp() {
				console.log(this.autoPlayTemp, 'autoPlayTemp')
				this.$emit('update:autoPlay', this.autoPlayTemp);
			},
			loop(val) {
				this.loopTemp = val;
			},
			loopTemp() {
				this.$emit('update:loop', this.loopTemp);
			},
			muted(val) {
				this.mutedTemp = val;
			},
			mutedTemp() {
				this.$emit('update:muted', this.mutedTemp);
			},
		}
	}
</script>

<style scoped>

::v-deep .el-checkbox__label{
    color: #fff;
  }
</style>
